import { render, staticRenderFns } from "./DnWidget.vue?vue&type=template&id=782e8c70&"
import script from "./DnWidget.vue?vue&type=script&lang=js&"
export * from "./DnWidget.vue?vue&type=script&lang=js&"
import style0 from "./DnWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports